import React, {useState, useEffect} from "react"
import {useNavigate, useParams } from "react-router-dom";
import ReactMarkdown from 'react-markdown'
import ReactLoading from 'react-loading';
import rehypeRaw from 'rehype-raw'
import styles from "./modal.module.scss"
import closeButton from "images/instance_closeButton.png"

const Modal = (props) => {
  const [instanceData, setInstanceData] = useState();
  let { id } = useParams();
  let navigate = useNavigate();
  useEffect(() => {
    if(props.data) {
      const data = props.data.filter(instance => instance[0] === id)
      setInstanceData(data[0])
    }
  }, [id, props.data]);

  const layoutRender = () => {
    const layoutArray = props.layouts.find((layout) => {
      return layout[0] === instanceData[3]
    })
    switch (props.searchParams.get("lang")) {
      case 'en':
        return layoutArray[2]
      default:
        return layoutArray[1]
    }
  }

  const deviceRender = () => {
    const layoutArray = props.layouts.find((layout) => {
      return layout[0] === instanceData[3]
    })
    const deviceArray = props.devices.find((device) => {
      return device[0] === layoutArray[9]
    })
    switch (props.searchParams.get("lang")) {
      case 'en':
        return deviceArray[2]
      default:
        return deviceArray[1]
    }
  }

  const specRender = () => {
    const layoutArray = props.layouts.find((layout) => {
      return layout[0] === instanceData[3]
    })
    switch (props.searchParams.get("lang")) {
      case 'en':
        return layoutArray[8]
      default:
        return layoutArray[7]
    }
  }

  const titleRender = (en, zh) => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return en
      default:
        return zh
    }
  }

  const closeBtnLinkRender = () => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return  `/instance/${id}/?lang=en`
      default:
        return  `/instance/${id}`
    }
  }
  return (!instanceData || !props.data) ? (    
  <div className={styles.modalPage}>
    <div className={styles.modal}>
      <div className={styles.container}>
        <ReactLoading type="bubbles" color="#5A24FF" height={'10%'} width={'10%'} />
      </div>
      <div className={styles.closeButton}>
        <img alt='closeButton' src={closeButton} 
          onClick={() => {
            navigate(closeBtnLinkRender())
          }}
        />
      </div>
    </div>
  </div>) : 
  (
    <div className={styles.modalPage}>
      <div className={styles.modal}>
        <div className={styles.container}>
          <p className={styles.purple}>{titleRender('Layout Name', '版型名稱')}</p>
          <p>{layoutRender()}</p>
          <p className={styles.line}></p>
          <p className={styles.purple}>{titleRender('Ads Device', '目標裝置')}</p>
          <p>{deviceRender()}</p>
          <p className={styles.purple}>{titleRender('Spec', '素材規格')}</p>
          <ReactMarkdown rehypePlugins={[rehypeRaw]} children={specRender()} />
        </div>
        <div className={styles.closeButton}>
            <img alt='closeButton' src={closeButton}
              onClick={() => {
                navigate(closeBtnLinkRender())
              }}     
            />
        </div>
      </div>
    </div>
  );
}

export default Modal
